import React from 'react';

const DropdownBox = ({sortChange}) => {
    return (
        <div>
            <label><b>Sort by : </b></label>
            <select name="sort" id="sort" onChange={sortChange} className="pa1 ba b--green bg-lightest-blue">
                <option value="popular">Popular</option>
                <option value="rating">Highest Rated</option>
                <option value="upcoming">Upcoming</option>
            </select>
        </div>
    );
}

export default DropdownBox;